import { createSlice } from "@reduxjs/toolkit";
import type { Locale } from "antd/es/locale";
import enUS from "antd/locale/en_US";

interface IInitialState {
  language: Locale;
  collapsed: boolean;
  openKey: string[];
  selectMenuKey?: string[];
}

// 定义初始化数据
const initialState: IInitialState = {
  language: enUS,
  collapsed: false,
  openKey: [],
  selectMenuKey: [''],
};

const globalConstantsSlice = createSlice({
  name: "globalConstants",
  initialState,
  reducers: {
    // 修改全局语言
    changeLanguage(state, { payload }) {
      state.language = payload;
    },
    changeCollapsed(state, { payload }) {
      state.collapsed = payload;
    },
    changeOpenKey(state, { payload }) {
      state.openKey = payload;
    },
    changeSelectMenuKey(state, {payload}) {
      state.selectMenuKey = payload;
    }
  },
  extraReducers: {},
});

// 导出该action
export const { changeLanguage, changeCollapsed, changeOpenKey, changeSelectMenuKey } =
  globalConstantsSlice.actions;

// 默认导出,到处的文件需要在store入口文件引入
export default globalConstantsSlice.reducer;
